import { Injectable } from '@angular/core';
import { GoogleTags, GtmEvent, GtmPage } from '@bci/core/analytics';
import { environment } from 'src/environments';
import { category, gtmType } from './gtm-utils';
import { StoreService } from '../store/store.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleTagService {
  constructor(
    private googleTags: GoogleTags,
    private store: StoreService
  ) {}

  gtmSetup() {
    this.googleTags.setup({
      gtmId: environment.gtmId,
      defaultExtra: {
        flujo: category,
      },
      onPush: (data) => {
        if (!environment.production) {
          // @ts-ignore
          console.log(`GTM (${process.env.NODE_ENV})`, data);
        }
      },
    });
  }

  setEvent(event: GtmPage | GtmEvent, extra?: {}) {
    const data = {
      ...event,
      extra: {
        ...extra,
        'id-solicitud': this.store.userInfo?.cic,
        rut: this.store.userInfo?.rut,
        email: this.store.userInfo?.email,
        telefono: this.store.userInfo?.telefonoCelular
      },
    };
    this.gtmFnHandler[
      event?.hasOwnProperty('page')
        ? gtmType.PAGE_EVENT
        : gtmType.INTERACTIVE_EVENT
    ](data);
  }

  gtmFnHandler = {
    PAGE_EVENT: (data: any) => {
      data = {
        ...data,
        event: 'pagina-virtual',
      };
      this.googleTags.page(data);
    },
    INTERACTIVE_EVENT: (data: any) => {
      data = {
        ...data,
        event: 'evento-interactivo',
      };
      this.googleTags.event(data);
    },
  };
}
